module.exports = __webpack_public_path__ + "img/color-8.1fc0b8e.png";